__webpack_require__.p = "/Review_carousel/";